<div class="file-names" *ngIf="!loadingSpinner">
  <div class="file" *ngFor="let projectFile of taskFiles; trackBy: trackEntityById">
    <div class="file-icon"
         *ngIf="projectFile.ext !== 'jpg' && projectFile.ext !== 'jpeg' && projectFile.ext !== 'png' && projectFile.ext !== 'gif' && projectFile.ext !== 'webp'">
      <mat-icon class="material-icons-outlined md-18">{{getIcon(projectFile.ext)}}</mat-icon>
    </div>
    <div class="file-thumbnail"
         *ngIf="projectFile.ext === 'jpg' || projectFile.ext === 'jpeg' || projectFile.ext === 'png' || projectFile.ext === 'gif' || projectFile.ext === 'webp'"
         (click)="openFile(projectFile)">
      <img [src]="getTinyIcon(projectFile.id)">
    </div>

    <div class="file-name">
      <span (click)="openFile(projectFile)">{{projectFile?.name}}</span>
    </div>

    <div class="file-info">
      {{projectFile.uploadTime | date: 'MMM dd, yyyy'}}
    </div>

    <span class="delete-icon" (click)="deleteFile(projectFile)">
			<mat-icon>clear</mat-icon>
		</span>
  </div>
</div>

<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>

<mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
</mat-progress-bar>

<p-fileUpload mode="advanced" name="files" #filesForm [customUpload]="true"
              (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
              chooseLabel="Upload">
  <ng-template pTemplate="content">
    <div class="attachments-block" (click)="chooseFile()">
      <i class="pi pi-download" style="font-size: 130%; margin-bottom: 0.4em;"></i>
      <div>
        <span class="add-attachment">Choose a file</span>
        <span class="drop-here">, paste or drag it here.</span>
      </div>
    </div>
  </ng-template>
</p-fileUpload>
